import { RouterProvider } from "react-router-dom";
import { DesignLanguageStyles } from "@songtradr-one/components-frontend";
import { Logging } from "./logging/Logging";
import { router } from "./routing/AppRoutes";

export const App = () => (
  <Logging>
    <DesignLanguageStyles />
    <RouterProvider router={router} />
  </Logging>
);
